export const CUSTOMER_GRP_VIEW = 'CUSTOMER_GRP_VIEW';
export const CUSTOMER_GRP_VIEW_LOADED = 'CUSTOMER_GRP_VIEW_LOADED';
export const CUSTOMER_GRP_LIST_ALL = 'CUSTOMER_GRP_LIST_ALL';
export const CUSTOMER_GRP_LISTED_ALL = 'CUSTOMER_GRP_LISTED_ALL';
export const CUSTOMER_GRP_UNLOAD = 'CUSTOMER_GRP_UNLOAD';
